import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/filters/user/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const user = {
  get: apiPathFunc(pathBase),
} as const;
